import {
  Component,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { ModalID } from '../../models/constants';
// Third Party
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

// Services
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-text-modal',
  standalone: true,
  templateUrl: './text-modal.component.html',
  styleUrl: './text-modal.component.scss',
  imports: [],
})
export class TextModalComponent implements OnDestroy {
  @ViewChild('yes_no_modal', { static: false }) yes_no_modal: TemplateRef<any>;

  @Input() context: any;
  header: string;
  optional_details: {};
  modal_id: number;

  modalRef: BsModalRef;
  modalConfig = {
    animated: true,
  };

  yn_options: ModalOptions = {
    class: 'modal-dialog, modal-dialog-centered',
    backdrop: 'static',
    ignoreBackdropClick: true,
    keyboard: false,
  };

  constructor(
    protected element: ElementRef,
    private modalService: BsModalService,
    private sharedService: SharedService
  ) {
  }

  ngOnInit(): void {
    this.modal_id = this.modalService.config.id as number;    
   
  }

  // Closes the Modal
  closeModal() {
    this.modalService.hide(this.modal_id);
  }



  ngOnDestroy() {
//    this.sub.unsubscribe();
}
submitClick() {
    this.sharedService.closeModal(ModalID.text_modal);
  }
}
